import React from "react";
import Toggle from "./Toggle";

interface ShowPersonalToggleProps {
  show: boolean;
  onChange: (show: boolean) => void;
}

/**
 * Switch controlling whether personal ("My workspace") workspaces are included.
 * They are excluded by default on every page — this opts back in on demand.
 *
 * A page using this must widen both the workspace dropdown *and* its data
 * request. Personal workspaces are not monitored, and the endpoints that carry
 * `monitored_only` default it to true, so widening only the dropdown left the
 * toggle looking functional while a personal workspace selected from it
 * returned an empty table. "No rows" and "outside the requested scope" are the
 * same screen.
 */
export default function ShowPersonalToggle({ show, onChange }: ShowPersonalToggleProps) {
  return (
    <Toggle
      checked={show}
      onChange={onChange}
      label="Show personal workspaces"
      title="Personal ('My workspace') workspaces are outside SOX scope and excluded by default. Including them widens this view beyond the monitored estate."
    />
  );
}
